import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setBookingRateOnBookingAtom = atom(
  null,
  (get, set, { rate }: { rate: { id: string } }) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;

    const newBooking = {
      ...booking,
      rateId: rate.id,
    };
    set(currentBookingAtom, newBooking);
  }
);
